import { formattingLocale } from "../i18n/formattingLocale";
const MONEY_FORMATTERS = new Map();
const POINTS_FORMATTER = new Intl.NumberFormat(formattingLocale(), {
  maximumFractionDigits: 0,
});

function moneyFormatter(currency) {
  const normalizedCurrency = String(currency || "EUR").toUpperCase();
  if (!MONEY_FORMATTERS.has(normalizedCurrency)) {
    MONEY_FORMATTERS.set(
      normalizedCurrency,
      new Intl.NumberFormat(formattingLocale(), {
        style: "currency",
        currency: normalizedCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }
  return MONEY_FORMATTERS.get(normalizedCurrency);
}
export function isMinorAmount(value) {
  return Number.isSafeInteger(value);
}

export function formatMoneyMinor(value, currency = "EUR", options = {}) {
  if (!isMinorAmount(value)) return options.unavailableLabel || "Indisponible";
  return moneyFormatter(currency).format(value / 100);
}

export function formatPoints(value, options = {}) {
  if (!Number.isSafeInteger(value)) return options.unavailableLabel || "Indisponibles";
  return `${POINTS_FORMATTER.format(value)} pts`;
}

export function formatWalletValue({
  kind,
  value,
  currency = "EUR",
  hidden = false,
  unavailableLabel,
} = {}) {
  if (hidden && (isMinorAmount(value) || Number.isSafeInteger(value))) {
    return kind === "points" ? "•••• pts" : "•••• €";
  }
  if (kind === "points") return formatPoints(value, { unavailableLabel });
  return formatMoneyMinor(value, currency, { unavailableLabel });
}

export function formatDateTime(value, fallback = "Date indisponible") {
  const parsed = value ? new Date(value) : null;
  if (!parsed || Number.isNaN(parsed.getTime())) return fallback;
  return new Intl.DateTimeFormat(formattingLocale(), {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(parsed);
}

export function formatLastRefresh(value) {
  const parsed = value ? new Date(value) : null;
  if (!parsed || Number.isNaN(parsed.getTime())) return "Jamais actualisé";
  return `Actualisé le ${formatDateTime(parsed)}`;
}
